export enum Permission {
    Candidate = "candidate",
    Editorial = "editorial",
    UsersManager = "users-manager",
    Speaker = "speaker",
}

export const PermissionInfo: Record<Permission, { label: string; help: string }> = {
    [Permission.Candidate]: {
        label: "Candidat",
        help: "Permet d'avoir des projets",
    },
    [Permission.Editorial]: {
        label: "Éditorial",
        help: "Permet d'éditer les briefs",
    },
    [Permission.UsersManager]: {
        label: "Gestion des utilisateurs",
        help: "Permet de voir et gérer les utilisateurs",
    },
    [Permission.Speaker]: {
        label: "Speaker",
        help: "Permet de rédiger des emails et de consulter les envois",
    },
};
